"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Aside_1 = __importDefault(require("../../../Aside"));
var Link_1 = __importDefault(require("../../../../navigation/Link"));
var typography_1 = require("../../../../typography");
var styles_1 = require("./styles");
var MetaListItem = function (_a) {
    var _b = _a.fullWidth, fullWidth = _b === void 0 ? false : _b, title = _a.title, href = _a.href, content = _a.content, isExternal = _a.isExternal;
    var children;
    if (typeof content !== 'string') {
        children = react_1.default.createElement(react_1.default.Fragment, null, content);
    }
    else if (href) {
        children = (react_1.default.createElement(typography_1.Body, { "data-component-name": "MetaListItem", level: "3" },
            react_1.default.createElement(Link_1.default, { href: href, isExternal: isExternal }, content)));
    }
    else {
        children = react_1.default.createElement(typography_1.Body, { level: "3" }, content);
    }
    return (react_1.default.createElement(styles_1.Wrapper, { "data-component-name": "MetaListItem", "$fullWidth": fullWidth },
        react_1.default.createElement(Aside_1.default, { level: "2", label: title }, children)));
};
exports.default = MetaListItem;
